import { useCallback, useRef } from 'react';

// the cb function only change when the dependencies change
export const useDedupedCallback = <TDep>(func: () => unknown, deps: TDep[]) => {
  const prevDepRef = useRef<TDep[]>([]);

  const cb = useCallback(() => {
    const isDuped =
      deps.length === prevDepRef.current.length &&
      deps.every((dep, i) => Object.is(dep, prevDepRef.current[i]));

    if (isDuped) {
      return;
    }

    func();
    prevDepRef.current = deps;
  }, [deps, func]);

  return cb;
};
